export enum OfferVasTypeOption {
  DOCUMENT = 'fdc3c413-f32a-4671-8b06-008b60b921ea',
  ADDITIONAL_SERVICES = 'a331493a-1dbf-4c21-82e1-ba7752615cdd'
}
